import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=1efd5e1e&scoped=true&"
import script from "./TransactionsList.vue?vue&type=script&lang=js&"
export * from "./TransactionsList.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsList.vue?vue&type=style&index=0&id=1efd5e1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd5e1e",
  null
  
)

export default component.exports